let bg;
export default bg = {
    "name": "   NordVPN - Bulgaria - New",
    "public_id": "f696de41-7d9a-419e-9a5c-03175760213f",
    "campaign": "b494945a-5963-4a57-b2d5-2a8755af6134",
    "layout": "FULL_WIDTH",
    "template": "landscape",
    "approach": "DEFAULT",
    "flow": "PIN_FLOW",
    "prep_step": false,
    "supported_languages": {
        "bu": "bu"
    },
    "country_code": "bg",
    "country_name": "Bulgaria",
    "logo_url": "https://d388jo7ckl8y3b.cloudfront.net/pages/page_logo__9614.png",
    "logo_position": "CENTER",
    "logo_size": "Small",
    "font_family": "Inter",
    "text_color": "#000000",
    "titles_color": "#000000",
    "button_text_color": "#000000",
    "button_primary_color": "#e02f1f",
    "background_color": "#ffffff",
    "boxed_background_color": "#ffffff",
    "header_background_color": "#ffffff",
    "background_image": "",
    "player_image": "",
    "featured_image": "https://d388jo7ckl8y3b.cloudfront.net/pages/page_fi__3950.png",
    "texts": {
        "bu": [
            {
                "title": "Най-модерният VPN",
                "sec_title": "Осигурете връзката си днес с NordVPN",
                "button_text": "ПРОДЪЛЖИ",
                "description": "<p>Въведете мобилния си номер, за да защитите мрежата си.</p>",
                "step_one_text": "стъпка 1: Въведете вашия номер",
                "step_two_text": "стъпка 2: Потвърдете номера",
                "button_caption": "Цена 24.00 лв. с ДДС на месец",
                "paragraph_under_button": "<p>&nbsp;</p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n<p>NordVPN е услуга за виртуална частна мрежа (VPN), която подобрява онлайн поверителността и сигурността чрез криптиране на интернет трафика и маскиране на IP адресите на потребителите. Това позволява на потребителите да заобикалят географските ограничения, да имат достъп до съдържание от всяка точка на света и да сърфират в мрежата анонимно. Услугата е на база на месечен абонамент и е на цена от 24,00 лв с ДДС. Ще получите ПИН код, който трябва да въведете, за да потвърдите плащането и активирането на абонамента. Абонаментът може да бъде прекратен по всяко време чрез изпращане на STOP NORD на номер 14703. ко се нуждаете от подкрепа, свържете се с нас на имейл nordvpn.bg@silverlines.info или се обадете на +35924928370. Тази услуга е предоставена от Nordvpn S.A.</p>"
            },
            {
                "title": "Най-модерният VPN",
                "sec_title": "Осигурете връзката си днес с NordVPN",
                "button_text": "потвърди",
                "description": "<p>Въведете получения код за потвърждение</p>",
                "step_one_text": "стъпка 1: Въведете вашия номер",
                "step_two_text": "стъпка 2: Потвърдете номера",
                "button_caption": "",
                "paragraph_under_button": "<p>NordVPN е услуга за виртуална частна мрежа (VPN), която подобрява онлайн поверителността и сигурността чрез криптиране на интернет трафика и маскиране на IP адресите на потребителите. Това позволява на потребителите да заобикалят географските ограничения, да имат достъп до съдържание от всяка точка на света и да сърфират в мрежата анонимно. Услугата е на база на месечен абонамент и е на цена от 24,00 лв с ДДС. Ще получите ПИН код, който трябва да въведете, за да потвърдите плащането и активирането на абонамента. Абонаментът може да бъде прекратен по всяко време чрез изпращане на STOP NORD на номер 14703. ко се нуждаете от подкрепа, свържете се с нас на имейл nordvpn.bg@silverlines.info или се обадете на +35924928370. Тази услуга е предоставена от Nordvpn S.A.</p>"
            }
        ]
    },
    "text_above_player": "",
    "bottom_text": "",
    "terms_text": "Terms & Conditions",
    "terms_url": "https://dcb-checkout.com/terms-of-service.html",
    "policy_text": "Privacy Policy",
    "policy_url": "https://dcb-checkout.com/privacy-policy.html",
    "terms_agreement_text": "Съгласен съм с Условията за ползване,I agree to the Terms of Use,,Съгласен съм с Условията за ползване,I agree to the Terms of Use,I agree,I agree,,I agree,I agree,Съгласен съм с Условията за ползване,I agree to the Terms of Use,,Съгласен съм с Условията",
    "sticky_top_right_text": "None",
    "terms_checkbox_switch": true,
    "terms_autocheck_with_click": true,
    "show_carriers": false,
    "show_rating": false,
    "show_country_flag": true,
    "validate_msisdn": true,
    "default_terms_switch_status": false,
    "append_terms_link_to_consent": false,
    "open_sms_composer": false,
    "about_text": "",
    "about_url": "None",
    "disclaimer_text": "",
    "disclaimer_url": "None",
    "contact_us_text": null,
    "contact_us_url": "https://dcb-checkout.com/nord-vpn/contact-us-nord-vpn.html",
    "animation_enabled": true,
    "phone_mask": "# ### #####",
    "is_testing": false,
    "translations": {
        "bu": {
            "about": "",
            "terms": "правила за ползване",
            "policy": "Политика за поверителност",
            "contact": "Свържете се с нас",
            "disclaimer": "",
            "bottom_text": "",
            "terms_agreement": "Съгласен съм с Условията за ползване",
            "text_above_player": ""
        }
    },
    "otp_length": "",
    "button_shape": "Rounded"
};
